import { useVesselStore } from 'src/context/VesselContext';
import { Coating } from 'src/types/ViewModel/Vessel/Coating';

const useUpdateCoatings = () => {
    const { selectedVessel } = useVesselStore();

    const updateCoatings = (coatings: Coating[]) => {
        if (!selectedVessel || !coatings) return;

        selectedVessel.cargoTanks?.forEach((tank) => {
            tank.coating = coatings.find((c) => c.id === tank.coatingId);
        });
    };

    return { updateCoatings };
};
export default useUpdateCoatings;
